export const ParticlesConfig = {
  fpsLimit: 60,
  background: {
    color: "transparent",
  },
  preset: "links",
};
